import { render, staticRenderFns } from "./TopUpAdmin.vue?vue&type=template&id=724f58ba&scoped=true&"
import script from "./TopUpAdmin.vue?vue&type=script&lang=js&"
export * from "./TopUpAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TopUpAdmin.vue?vue&type=style&index=0&id=724f58ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f58ba",
  null
  
)

export default component.exports